"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDiffTextOperation = exports.findDiff = void 0;
const vscode_diff_1 = require("vscode-diff");
const TextOperation_1 = require("./TextOperation");
/**
 * Takes two strings and uses an alghoritm to figure out exactly where changes has been made
 * to the string. Imagine Prettier adding semi colons, this diff will identify as an array
 * each semicolon inserted, meaning the operation we create from this only holds
 * the semicolon changes.
 */
function findDiff(originalText, modifiedText, pretty) {
    return (0, vscode_diff_1.stringDiff)(originalText, modifiedText, pretty);
}
exports.findDiff = findDiff;
/**
 * Takes two strings and returns an operation representing the exact changes made between
 * the two strings. Normally the first difference in the strings would state that everything
 * after that point is also different, but not here. It uses an alghoritm to figure this
 * stuff out
 */
function createDiffTextOperation(originalText, modifiedText) {
    const ot = new TextOperation_1.TextOperation();
    // Quickly return if nothing changed...
    if (originalText === modifiedText) {
        ot.retain(originalText.length);
        return ot;
    }
    const diffs = findDiff(originalText, modifiedText, false);
    let previousOriginalEndIndex = 0;
    diffs.forEach((change) => {
        const originalStartIndex = change.originalStart;
        const originalEndIndex = change.originalStart + change.originalLength;
        const charsToRetain = originalStartIndex - previousOriginalEndIndex;
        if (charsToRetain > 0) {
            ot.retain(charsToRetain);
        }
        else if (charsToRetain < 0) {
            throw new Error("Invalid diff change start index, overlapping changes detected");
        }
        previousOriginalEndIndex = originalEndIndex;
        const oldText = originalText.substring(originalStartIndex, originalEndIndex);
        const newText = modifiedText.substring(change.modifiedStart, change.modifiedStart + change.modifiedLength);
        if (oldText !== newText) {
            ot.insert(newText);
            ot.delete(change.originalLength);
        }
    });
    // retain remaining characters
    const remainingChars = originalText.length - ot.baseLength;
    if (remainingChars > 0) {
        ot.retain(remainingChars);
    }
    else if (remainingChars < 0) {
        throw new Error("Invalid text diff, remaining chars is negative");
    }
    return ot;
}
exports.createDiffTextOperation = createDiffTextOperation;
//# sourceMappingURL=data:application/json;base64,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